export default __webpack_public_path__ + "static/media/Change_password.4db2ea16.svg";